module.exports = __webpack_public_path__ + "img/DSC_2842-xl.72410f37.png";